export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
        <div>
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-7 h-7 rounded-md bg-gradient-to-br from-[#007AFF] via-[#00F0FF] to-[#8B5CF6]">
              <span className="w-1.5 h-1.5 rounded-sm bg-black/60" />
            </span>
            <span className="font-display text-lg font-semibold">Vyomex</span>
          </div>
          <p className="text-white/50 text-sm mt-3 max-w-xs">
            AI automation systems for local service businesses that want to scale without chaos.
          </p>
        </div>
        <div className="flex flex-col items-center md:items-end gap-2 text-sm text-white/60">
          <a
            href="mailto:hi@vyomex.org"
            className="hover:text-[#00F0FF] transition"
            data-testid="footer-email"
          >
            hi@vyomex.org
          </a>
          <span className="text-white/30 text-xs uppercase tracking-[0.2em]">
            © {new Date().getFullYear()} Vyomex. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}
